import Table from './src/JsmTable.vue'

Table.install = (Vue) => {
  Vue.component(Table.name, Table)
}

export default Table
